/**
 * Envío UI-3 · traduce una marca a estilo de texto del timeline.
 * El render (FFmpeg) sólo tiene 4 tipografías: si la de la marca no está,
 * se avisa y se deja la actual.
 */
const FONT_KEYS = [
  ['montserrat', /montserrat/i],
  ['bebas', /bebas/i],
  ['playfair', /playfair/i],
  ['inter', /\binter\b/i],
];

export function parseBrandFont(text) {
  if (!text || typeof text !== 'string') return null;
  const hit = FONT_KEYS.find(([, re]) => re.test(text));
  const w = /\b([1-9]00)\b/.exec(text);
  return {
    family: hit ? hit[0] : null,
    weight: w ? Number(w[1]) : null,
    raw: text.trim(),
  };
}

const byRole = (colors, roles) => {
  for (const r of roles) {
    const c = colors.find((x) => x && x.role === r && x.hex);
    if (c) return c.hex;
  }
  return null;
};

/**
 * @param {object} brand  {fields:{colors:[{hex,role}], fonts:{titles,body}}}
 * @param {'titles'|'body'} use  qué tipografía de la marca tomar
 * @returns {{patch: object, missingFont: string|null}}
 */
export function brandTextPatch(brand, use = 'titles') {
  const f = (brand && brand.fields) || {};
  const colors = Array.isArray(f.colors) ? f.colors.filter((c) => c && c.hex) : [];
  const fonts = f.fonts || {};
  const font = parseBrandFont(fonts[use] || fonts.titles || fonts.body);
  const patch = { preset: 'custom' };
  let missingFont = null;
  if (font) {
    if (font.family) patch.font_family = font.family;
    else missingFont = font.raw;
    if (font.weight) patch.font_weight = font.weight;
  }
  const text = byRole(colors, ['text']);
  const main = byRole(colors, ['primary', 'accent']) || (colors[0] && colors[0].hex) || null;
  patch.color = text || '#FFFFFF';
  if (main && main.toUpperCase() !== patch.color.toUpperCase()) {
    patch.box = { enabled: true, color: main };
  }
  return { patch, missingFont };
}
